import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "preferential_body_nr"
};
const _hoisted_4 = {
  class: "preferential_list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "indate"
};
const _hoisted_8 = {
  key: 1,
  style: {
    "display": "flex",
    "width": "100%",
    "align-items": "center",
    "justify-content": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "我的卡片", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$setup.cardRecordsList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "ka_img",
      onClick: $event => $setup.push(item)
    }, [_createElementVNode("img", {
      src: item.status != '未激活' ? item.imgUrlM : item.unImgUrlM,
      alt: ""
    }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, "有效期：" + _toDisplayString(item.status != '未激活' ? item.indate : '****'), 1)], 8, _hoisted_5)])]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [_createElementVNode("img", {
    style: {
      "width": "40rem",
      "margin-top": "20%"
    },
    src: "https://www.mimodental.com/assets/imgData/img/new/que.png"
  }, null, -1)])))])])]);
}